import { CoreIconButton, CoreSkeletonWrapper, OverflowText } from "@verity/components/core";
import CloseXIcon from "../../../../../images/reports/closeX.svg?react";
import i18n from "../../../../../i18n";
import { Stack } from "@mui/material";

type ResultViewBackButtonProps = {
	onBackButtonClick: () => void;
	backLabel?: string;
	showBackButton?: boolean;
	/**
	 * Skeletons the label only, leaving the close button live. The button itself is never skeletoned:
	 * dismissing the view has to stay possible while the rest of it is still loading.
	 */
	labelLoading?: boolean;
};

export default function ResultViewBackButton({
	onBackButtonClick,
	backLabel,
	showBackButton,
	labelLoading,
}: ResultViewBackButtonProps) {
	// Both halves below are conditional, so a caller with neither a close button nor a label would
	// otherwise get an empty `Stack`: invisible, but still one child of the flex header laying it out,
	// and so still worth a `gap` of blank space before the first real control. That is the read-only
	// embeds — they withhold `setShowStudentResults`, which is what turns the close button off.
	if (!showBackButton && !labelLoading && !backLabel) {
		return null;
	}

	return (
		<Stack direction={{ xs: "row" }} alignItems="center" spacing={0.8}>
			{showBackButton && (
				<CoreIconButton
					variant="plain"
					onClick={onBackButtonClick}
					sx={{ padding: "4px" }}
					aria-label={i18n.t("result.components.resultsPage.proctoringResultsHeaderTSX.backButtonAriaLabel")}
				>
					<CloseXIcon aria-hidden="true" />
				</CoreIconButton>
			)}

			{(labelLoading || backLabel) && (
				<CoreSkeletonWrapper loading={!!labelLoading} width={150} height={"24px"}>
					<OverflowText
						variant="h1"
						fontWeight={600}
						fontSize="15px"
						style={{
							flexGrow: 1,
							maxWidth: "300px",
						}}
					>
						{backLabel}
					</OverflowText>
				</CoreSkeletonWrapper>
			)}
		</Stack>
	);
}
